export type GitNounAuthorTuple = readonly [name: string, picture: string | null];

type GitNounContributorLike = {
	readonly name?: string | null;
	readonly picture?: string | null;
};

const normalizeDisplayName = (name: string | null | undefined): string => {
	if (typeof name !== 'string') {
		return '';
	}
	return name.trim();
};

// Prioritized a customized photo over one with initals
const prioritizeAvatarWithoutInitials = (avatar1: string | null, avatar2: string | null) => {
	if (!avatar1) {
		return avatar2;
	}
	if (avatar1.includes('/initials/') && avatar2) {
		return avatar2;
	}
	return avatar1;
};

/**
 * Resolves the best author candidate for git nouns (commits / PRs) as a tuple of
 * [displayName, profilePictureUrl].
 *
 * Returns null if there is no usable name.
 */
export const resolveGitNounAuthors = (
	initialContributors: ReadonlyArray<GitNounContributorLike> | null | undefined,
	authorUser: GitNounContributorLike | null | undefined,
): GitNounAuthorTuple | null => {
	let authorName = null;
	let initialContributor =
		initialContributors && initialContributors.length > 0 ? initialContributors[0] : null;
	let authorPicture1 = initialContributor?.picture?.trim() ?? null;
	let authorPicture2 = authorUser?.picture?.trim() ?? null;

	if (initialContributor?.name && initialContributor.name.trim() !== '') {
		authorName = initialContributor.name.trim();
	} else if (authorUser?.name && authorUser.name.trim() !== '') {
		authorName = authorUser.name.trim();
	}

	if (authorName) {
		return [
			normalizeDisplayName(authorName),
			prioritizeAvatarWithoutInitials(authorPicture1, authorPicture2),
		];
	}

	return null;
};
